import React from 'react'
import { Container, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import ClientInfo from '../components/Clients/ClientInfo';
import PermissionWrapper from '../auth/PermissionWrapper';
import classnames from 'classnames';
import FormDisplay from '../components/Forms/FormDisplay';
import Reports from './Reports';

class Client extends React.Component {

    constructor(props) {
        super(props);

        this.selectedFormEntry = '';
        this.selectedInvestor = '';
        this.selectedFund = '';
        this.path = String(this.props.location.pathname).split('/');
        if (this.path[2] != null) {
            if (this.path[3]) {
                this.selectedFormEntry = '/' + this.path[3];
            }
            if (this.path[4]) {
                this.selectedInvestor = '/' + this.path[4];
            }
            if (this.path[5]) {
                this.selectedFund = '/' + this.path[5];
            }
            this.path[3] = this.path.filter((i, index) => index > 2).join('/');
            this.path.splice(4, 1000);
        }

        this.increment = 10;

        this.state = {
            clientReports: {
            }
        }

        this.tabs = [
            {
                name: 'Fund Info',
                permission: 'Fund Info',
                module: <ClientInfo
                    {...this.props}
                    clientInfo={this.state.clientReports.info}
                    handleUpdateClientInfo={this.handleUpdateClientInfo}
                    clientData={this.state.clientReports}
                    tab={1}
                    setCallback={this.setCallback}
                />
            },
            {
                name: 'Investor',
                permission: 'Investor',
                module: <FormDisplay
                    {...this.props}
                    formId={3}
                    tab={2}
                    setCallback={this.setCallback}
                />
            },
            {
                name: 'Investment Fund',
                permission: 'Investment Fund',
                module: <FormDisplay
                    {...this.props}
                    formId={1}
                    tab={3}
                    setCallback={this.setCallback}
                />
            },
            {
                name: 'Investment Entry',
                permission: 'Investment Entry',
                module: <FormDisplay
                    {...this.props}
                    formId={2}
                    selectedFormEntry={isNaN(parseInt(this.selectedFormEntry.replace('/', ''))) ? 0 : parseInt(this.selectedFormEntry.replace('/', ''))}
                    tab={4}
                    setCallback={this.setCallback}
                />
            },
            {
                name: 'Fund Valuation',
                permission: 'Fund Valuation',
                module: <FormDisplay
                    {...this.props}
                    formId={4}
                    selectedFormEntry={isNaN(parseInt(this.selectedFormEntry.replace('/', ''))) ? 0 : parseInt(this.selectedFormEntry.replace('/', ''))}
                    selectedInvestor={this.selectedInvestor.replace('/', '')}
                    selectedFund={this.selectedFund.replace('/', '')}
                    tab={5}
                    setCallback={this.setCallback}
                />
            },
            {
                name: 'Investment Log',
                permission: 'Investment Log',
                module: <Reports
                    {...this.props}
                    formId={5}
                    tab={6}
                    setCallback={this.setCallback}
                    setReport="investor-log"
                    hideTools={true}
                />
            },
            {
                name: 'Schedule K-1',
                permission: 'Schedule K-1',
                module: <FormDisplay
                    {...this.props}
                    formId={6}
                    tab={7}
                    setCallback={this.setCallback}
                />
            },
        ]

        this.state = {
            ...this.state,
            activeTab: this.path[2] != null ? Math.max(1, this.tabs.findIndex(tab =>
                this.props.replaceSpecialChars(tab.name) === this.props.replaceSpecialChars(this.path[2])) + 1) : 1,
            isLoaded: false,
            selectedClientReportId: 0,
            callbacks: [],
            selectedFormEntry: isNaN(parseInt(this.selectedFormEntry.replace('/', ''))) ? 0 : parseInt(this.selectedFormEntry.replace('/', ''))
        };
        this.callbacks = [];
    }

    componentDidMount = () => {
        this.props.log('Client.js/componentDidMount');
        this.getClientReports();
    }

    componentWillUnmount = () => {
        this.props.log('Client.js/componentWillUnmount');
        this.isUnmounted = true;
    }

    setCallback = (index, cb) => {
        this.props.log('Client.js/setCallback (index,cb)', index, cb);
        this.callbacks[index - 1] = cb;
        this.changeTab(this.state.activeTab)
    }

    changeTab = (tab) => {
        this.props.log('Client.js/changeTab (tab)', tab);
        if (this.callbacks[tab - 1] != null && typeof (this.callbacks[tab - 1] === 'function')) this.callbacks[tab - 1]();
        window.history.pushState({}, '', this.props.replaceSpecialChars(/*'/' + this.props.clientName + */'/company/' + this.tabs[tab - 1].name))
        this.setState({ activeTab: tab });
    }

    getClientReports = () => {
        this.props.log('Client.js/getClientReports');
        fetch('/api/clientReports/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState((prevState, props) => {
                        let return_value = {
                            clientReports: results.data,
                            isLoaded: true,
                        };
                        if (this.state.selectedClientReportId > 0) {
                            return_value.selectedReport = return_value.clientReports.reports.filter(report => report.id === this.state.selectedClientReportId)[0];
                        }
                        return return_value;
                    });
                } else {
                    this.props.addToast('Company info is not available.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    selectReport = (report) => {
        this.props.log('Client.js/selectReport (report)', report);
        this.setState({
            selectedClientReportId: report.id === this.state.selectedClientReportId ? 0 : report.id,
            selectedReport: report
        });
    }

    handleUpdateClientInfo = (obj) => {
        this.props.log('Client.js/handleUpdateClientInfo (obj)', obj);
        this.setState({
            clientReports: { ...this.state.clientReports, ...obj }
        }, () => {
            fetch('/api/clientInfo/', {
                method: 'PUT',
                body: JSON.stringify({
                    info: this.state.clientReports.info,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-DB': this.props.clientId
                }
            })
                .then(results => results.json())
                .then(this.getClientReports())
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    }

    formatAMPM = (date) => {
        this.props.info('Client.js/formatAMPM (date)', date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    render = () => {
        this.props.info('Client.js/render');
        if (!this.props.clientId) return (<p>No company selected.</p>)
        if (this.state.isLoaded) {
            return (
                <Container fluid className='mx-0 px-0'>
                    <Container>
                        <Nav tabs className="pb-0">
                            {this.tabs.map((tab, tabIndex) => (
                                <PermissionWrapper key={tabIndex} refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission={tab.permission}>
                                    <NavItem >
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === tabIndex + 1 })}
                                            onClick={() => this.changeTab(tabIndex + 1)}>
                                            {tab.name}
                                        </NavLink>
                                    </NavItem>
                                </PermissionWrapper>
                            ))}
                        </Nav>
                    </Container>
                    <TabContent activeTab={this.state.activeTab}>
                        {this.tabs.map((tab, tabIndex) => (
                            <PermissionWrapper key={tabIndex} refreshUser={this.props.refreshUser} {...this.props} {...this.state} hidden={true} allowedPermission={tab.permission}>
                                <TabPane tabId={tabIndex + 1} className="">
                                    {tab.module}
                                </TabPane>
                            </PermissionWrapper>
                        ))}
                    </TabContent>
                </Container>
            )
        } else {
            return (<h2>Loading...</h2>)
        }
    }
}

export default Client;